/**
 * An array of routes that are accessible to the public.
 * These routes do not require authentication
 * @type {string[]}
 */
export const publicRoutes: string[] = [
  "/",
  "/home",
  "/convert",
  "/new-verification",
];

/**
 * An array of routes that are not accessible to the public.
 * These routes require authentication
 * @type {string[]}
 */
export const privateRoutes: string[] = [
  "/history",
  "/profile",
  "/custom",
  "/voice-blending",
];

/**
 * An array of routes that are accessible only for admin role.
 * These routes require ADMIN role
 * @type {string[]}
 */
export const adminRoutes: string[] = ["/admin"];

export const redirectToHomeStartsWithRoutes: string[] = [
  "/convert",
  "/demo",
  "/custom",
  "/duets",
  "/voice-blending",
  "/how-to-use",
  "/how-to-use/file",
  "/how-to-use/microphone",
  "/how-to-use/youtube",
  "/how-to-use/custom-voice-tips",
];

export const redirectToHomeExcludeRoutes: string[] = [
  "/how-to-use/ai-mastering-tips",
];

/**
 * An array of routes that are use for authentication.
 * These routes will redirect logged-in users
 * @type {string[]}
 */
export const authRoutes: string[] = [
  "/login",
  "/register",
  "/reset",
  "/new-password",
];

/**
 * The prefix for API authentication routes.
 * Routes that start with this prefix are used for API
 authentication purposes
 * @type {string}
 */
export const apiAuthPrefix: string = "/api/auth";

export const apiRoute: string = "/api";

/**
 * The default redirect path after logging in
 * @type {string}
 */
export const DEFAULT_LOGIN_REDIRECT: string = "/";
